import {Component} from '@angular/core';

@Component({
    selector: 'snelstart-venture-fiscaal-feature-balans',
    templateUrl: './balans.component.html',
    styleUrls: ['./balans.component.scss'],
})
export class BalansComponent {}
